<!-- app-materia-card -->
<mat-expansion-panel class="dashboard-expansion-panel" #panel>
  <mat-expansion-panel-header style="white-space: nowrap;">
    <mat-panel-title>
      <!-- Título con la misma lógica de enlaces -->
      <ng-container *ngIf="materia.url && materia.url.length > 0; else noLinkMateria">
        <ng-container *ngIf="!materia.isExterno; else externalLink">
          <a [routerLink]="['/'].concat(materia.url.split('/'))">{{ materia.nombre }}</a>
        </ng-container>
        <ng-template #externalLink>
          <a [href]="materia.url">{{ materia.nombre }}</a>
        </ng-template>
      </ng-container>
      <ng-template #noLinkMateria>
        {{ materia.nombre }}
      </ng-template>
    </mat-panel-title>

    <!-- Acciones / badges a la derecha del header -->
    <span class="spacer"></span>

    <ng-container *ngFor="let item of materia.items">
      <!-- Si no hay link, mostramos el nombre plano como antes -->
      <ng-template #noItemLink>
        <span class="item-label">{{ item.nombre }}</span>
      </ng-template>

      <!-- Círculo con badge si hay cantidad -->
      <div
        class="circulo"
        *ngIf="panel.expanded && item.cantidad > 0"
        (click)="$event.stopPropagation(); getServiceData(item)"
        matTooltip="{{ item.nombre }}"
        aria-label="{{ item.nombre }}"
        style="cursor: pointer; margin-left: 6px;"
      >
        <mat-icon [matBadge]="item.cantidad" matBadgeSize="small" aria-hidden="false">
          more_vert
        </mat-icon>
      </div>
    </ng-container>
  </mat-expansion-panel-header>

  <!-- CONTENIDO DEL PANEL -->
  <div class="button-grid">
    <ng-container *ngFor="let item of materia.items">
      <div *ngIf="item">
        <!-- Botón con la misma lógica de interno/externo -->
        <ng-container *ngIf="item.url && item.url.length > 0; else noItemLink">
          <ng-container *ngIf="!item.isExterno; else externalItemLink">
            <button mat-stroked-button class="custom-button" (click)="navigate(item.url)">
              <mat-icon class="button-icon" color="accent">{{ item.urlIcon }}</mat-icon>
              <span class="button-text">{{ item.nombre }}</span>
            </button>
          </ng-container>
          <!-- <ng-template #externalItemLink>
            <button mat-stroked-button class="custom-button" (click)="openExternalLink(item.url)">
              <mat-icon class="button-icon" color="accent">{{ item.urlIcon }}</mat-icon>
              <span class="button-text">{{ item.nombre }}</span>
            </button>
          </ng-template> -->
        </ng-container>

        <!-- DETALLE: AlumnoAsistencia -->
        <ng-container *ngIf="item.tipo == 'AlumnoAsistencia' && item.detalle">
          <div class="detail-container mat-elevation-z8">
            <div class="inline-flex">
              <div class="flex-wrap" style="justify-content:space-between;">
                <label class="inline-flex"><strong>Ausencias</strong></label>
                <label class="inline-flex"><strong>Retardos</strong></label>
                <label class="inline-flex"><strong>Total</strong></label>
              </div>
              <ng-container *ngFor="let appendable of ['', '0', '1', '2', '3']">
                <div class="flex-wrap">
                  <ng-container *ngFor="let tipoAusencia of ['A' + appendable, 'R' + appendable, 'AR' + appendable]; index as i">
                    <div class="inline-flex">
                      <ng-container *ngIf="i < 2">
                        {{ tipoAusencia }}:
                      </ng-container>
                      {{ i == 1 ? (item.detalle | asistenciaCodigo: tipoAusencia).retardos
                                : (item.detalle | asistenciaCodigo: tipoAusencia).numerico }}
                      <ng-container *ngIf="i == 2">
                        <small style="color: gray;">
                          ({{ (item.detalle | asistenciaCodigo: tipoAusencia).porcentaje }}%)
                        </small>
                      </ng-container>

                      <ul class="detail-list" *ngIf="i < 2 && (item.detalle | asistenciaCodigo: tipoAusencia).fechas.length > 0">
                        <li *ngFor="let fecha of (item.detalle | asistenciaCodigo: tipoAusencia).fechas" style="color: gray">
                          <small>{{ fecha }}</small>
                        </li>
                      </ul>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </div>
        </ng-container>

        <!-- DETALLE: Estudio Unidad (Alumno / Profesor) -->
        <ng-container *ngIf="(item.tipo == 'AlumnoEstudioUnidad' || item.tipo == 'ProfesorEstudioUnidad') && item.detalle">
          <div class="detail-container mat-elevation-z8" style="display:block">
            <label><strong>Unidades, evidencias y retroalimentación</strong></label>

            <ul *ngIf="item.detalle.length > 0; else noUnidades">
              <li *ngFor="let unidad of item.detalle">
                <ng-container *ngIf="item.tipo == 'AlumnoEstudioUnidad'; else unidadProfesor">
                  <a [routerLink]="['/', 'estudio', 'familia', 'alumno', hijo.id, 'unidad', unidad.id]">
                    <b>{{ unidad.nombre }}</b>
                  </a>
                </ng-container>
                <ng-template #unidadProfesor>
                  <a [routerLink]="['/', 'estudio', 'unidad', unidad.id]">
                    <b>{{ unidad.nombre }}</b>
                  </a>
                </ng-template>

                <ul *ngIf="unidad.eventos && unidad.eventos.length > 0; else noEventos" style="padding-left: 6px">
                  <li *ngFor="let evento of unidad.eventos" class="flex-wrap" style="align-items: center;">
                    <ng-container *ngIf="item.tipo == 'AlumnoEstudioUnidad'; else eventoProfesor">
                      <a [routerLink]="['/', 'estudio', 'autoevaluacion', 'eventoMateria', evento.id, 'alumno', hijo.id]">
                        <small class="inline-flex" style="flex-grow: 3;">{{ evento.nombre }} {{ evento.fechaCorta }}</small>
                      </a>
                    </ng-container>
                    <ng-template #eventoProfesor>
                      <a
                        [routerLink]="['/', 'estudio', 'unidad', unidad.id, 'retroalimentacion', 'evento', evento.unidadEventoId, 'materia', evento.materiaId]">
                        <small class="inline-flex" style="flex-grow: 3;">{{ evento.nombre }} {{ evento.fechaCorta }}</small>
                      </a>
                    </ng-template>

                    <span class="spacer"></span>
                    <mat-icon class="md-14">chat_bubble</mat-icon>
                    <sup>{{ evento.comentariosNuevos }}</sup>
                  </li>
                </ul>

                <ng-template #noEventos>
                  <p style="opacity: .6"><small>Sin eventos registrados</small></p>
                </ng-template>
              </li>
            </ul>

            <ng-template #noUnidades>
              <p style="opacity: .6"><small>Sin unidades publicadas</small></p>
            </ng-template>
          </div>
        </ng-container>

      </div>
    </ng-container>
  </div>
</mat-expansion-panel>
